import { FeatureFragment, isFeatureFragment } from './FeatureFragment'

import categoryRawString from '../Category.graphql'

export const categoryString = categoryRawString

export type Category = {
  id: string
  title: string
  sortOrder: number
  features: FeatureFragment[]
}

export const isCategory = (fragment: any): fragment is Category =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  typeof fragment.sortOrder === 'number' &&
  Array.isArray(fragment.features) &&
  fragment.features
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isFeatureFragment(next) as boolean),
      true,
    )
